import React from "react";

export default function Loader({isLoading}) {
  return (
    isLoading && 
  (<div className="loaderBox">
    <div className='lds-ripple'>
      <div></div>
      <div></div>
    </div>
    </div>)
  )
}